// React related imports
import { FC } from 'react';
import { Controller } from 'react-hook-form';

// Components
import { Input } from '@GxT-Team/gxt-components';
import InputError from '../../../../../components/inputError/InputError';

// Types
import { IQueryModalFields } from './types';

const QueryModalFields: FC<IQueryModalFields> = ({ control, errors, dataSourceVariables }) => {
  return (
    <form className="w-[50rem]">
      {dataSourceVariables?.map((variable, index) => {
        const key = variable.key;
        return (
          <div key={`${key}-${index}`} className="w-1/2">
            <Controller
              name={`${key}`}
              control={control}
              defaultValue=""
              rules={{ required: true }}
              render={({ field }) => (
                <Input
                  {...field}
                  label={key?.toUpperCase()}
                  placeholder={`Enter value for ${key}`}
                  error={
                    !!(errors?.variables as Record<string, { message?: string }> | undefined)?.[key]
                  }
                  helpText={<InputError errors={errors} field={`variables.${key}`} />}
                />
              )}
            />
          </div>
        );
      })}
    </form>
  );
};

export default QueryModalFields;
